
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get Cliente() { return this.Chat.Cliente; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {

        }

        

    }
